import PropTypes from 'prop-types';

const relationshipItemDetailProp = PropTypes.shape({
	displayPrice: PropTypes.number,
	imageUrl: PropTypes.string,
	productName: PropTypes.string,
	productUrl: PropTypes.string,
	skuInputType: PropTypes.number
});

const relationshipItemProp = PropTypes.shape({
	shortSku: PropTypes.string,
	label: PropTypes.string,
	sortOrder: PropTypes.number,
	relationshipItemDetail: relationshipItemDetailProp
});

export { relationshipItemProp, relationshipItemDetailProp };
